import { render } from "./RegistrationFirstStepPage.vue?vue&type=template&id=71912cdd&scoped=true"
import script from "./RegistrationFirstStepPage.vue?vue&type=script&lang=js"
export * from "./RegistrationFirstStepPage.vue?vue&type=script&lang=js"

import "./RegistrationFirstStepPage.vue?vue&type=style&index=0&id=71912cdd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71912cdd"]])

export default __exports__